import { render, staticRenderFns } from "./agent-details-loader.vue?vue&type=template&id=a25851d0"
import script from "./agent-details-loader.vue?vue&type=script&lang=js"
export * from "./agent-details-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports